import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, BrowserEvents } from './constants';
import { fixMobileHover, sortAnimations, initGTM, setCookiesAllowed, setDisclaimerAccepted, scrollTo } from './helpers';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";

// ---------- jQuery Related ----------

$Elements.document.on(BrowserEvents.page.enter, () => {

	// ---------- Fix VH ----------

	$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
	$Elements.window.trigger('resize');

	// ---------- Fix Mobile Hover ----------

	$Elements.window.on('load', () => fixMobileHover());

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.matchMedia(sortAnimations(Animations));

	// ---------- Links ----------

	$Elements.body.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.body.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {
			scrollTo(target);
		}
	});

	$Elements.body.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});

	$('.main-tabs .btn').on('hidden.bs.tab', () => scrollTo(0, 0));

	// ---------- Disclaimer ----------


	$('#disclaimer').each(async function() {

		const $this = $(this);
		const form = $this.find('.disclaimer-form');
		const tooltip = form.find('.invalid-tooltip');
		const input = form.find('input');

		input.on('input', () => input.removeClass('is-invalid'));

		form.on('submit', async e => {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();

			input.removeClass('is-invalid');
			tooltip.empty();

			const access = form[0].dataset.access;
			const invalid = form[0].dataset.invalid;
			const empty = form[0].dataset.empty;
			const data = new FormData(form[0]);
			const password = data.get('password');
			const hash = btoa(password);

			if(!password.length) {
				tooltip.text(empty);
				input.addClass('is-invalid');
			}
			else if(hash !== access) {
				tooltip.text(invalid);
				input.addClass('is-invalid');
			}
			else {
				$this.alert('close');
				$Elements.body.removeClass('disclaimer-open');
				$this.on(BrowserEvents.transition.end, () => $Elements.body.removeClass('has-disclaimer'));
				setDisclaimerAccepted();
			}
		});
	});

	// ---------- Cookies ----------

	initGTM();
	setCookiesAllowed('true');

});
